import Type1 from "./packingItemType1";

export default Type1;
